import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useSession } from '@stores/globalData/globalData.store'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'
import { languages } from '@utils/i18n'

const LanguageSection: React.FC = () => {
  const session = useSession()
  const { t } = useTranslation()

  const changeLanguage = async (code): Promise<void> => {
    const [resp] = await http.post(ApiRoutes.clientLocalePath(), {
      locale: code,
      user: session.current_user,
    })
    if (resp) window.location.reload()
  }

  return (
    <ul className="p-2.5 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">{t('footer.language')}</li>
      {languages.map((lang) => (
        <li className="py-0.5" key={lang.code}>
          <button
            onClick={() => changeLanguage(lang.code)}
            className={classNames('link', {
              'font-medium': lang.code === session.locale,
            })}
            type="button">
            {lang.label}
          </button>
        </li>
      ))}
    </ul>
  )
}

export default LanguageSection
